import React from "react";
import { Component } from "react";
import JobsList from "views/profile/components/my-jobs/components/JobsList";

class MyJobs extends Component {

  render() {
    return (
      <div className="">
        <div className="lg:text-right md:text-right text-center mb-6 lg:mt-0 md:mt-0 mt-6">
          <button className="outline-button w-230px h-50px fsize16 font-semibold rounded-25px">
            SHOW PENDING
           
          </button>
        </div>

        <div>
          <div className="rounded-8px bgF7F7F7 h-47px flex  justify-end pr-8">
            <div className="flex items-center">
              <div className="flex items-center addborder-select mr-8">
                <p className="fsize14 font-semibold text-black ">Sort by:</p>
                <div class="form-group  border-none ">
                  <select className="select-dropdown-c fsize14 ">
                    <option value="Newest">Newest </option>
                    <option value="Newest">Newest</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="flex items-center">
              <p className="text053C6D fsize14 font-bold">ADD FILTER +</p>
            </div>
          </div>

          <JobsList />
        </div>
      </div>
    );
  }
}
export default MyJobs